/* eslint-disable react/style-prop-object */
import React from "react";

const VariablesIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.475 12.425L7.575 11.325L5.25 9L7.55 6.7L6.45 5.6L3.05 9L6.475 12.425ZM11.525 12.425L14.95 9L11.525 5.575L10.425 6.675L12.75 9L10.425 11.325L11.525 12.425ZM1.5 18C1.1 18 0.75 17.85 0.45 17.55C0.15 17.25 0 16.9 0 16.5V1.5C0 1.1 0.15 0.75 0.45 0.45C0.75 0.15 1.1 0 1.5 0H16.5C16.9 0 17.25 0.15 17.55 0.45C17.85 0.75 18 1.1 18 1.5V16.5C18 16.9 17.85 17.25 17.55 17.55C17.25 17.85 16.9 18 16.5 18H1.5ZM1.5 16.5H16.5V1.5H1.5V16.5Z"
      fill="#000000"
    />
  </svg>
);
VariablesIcon.defaultProps = {
  className: "",
  color: "",
};

export default VariablesIcon;
